import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

type RewriteInsufficientSourcesDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  translationKeyPrefix: 'riskAssessmentPage' | 'manualGenerationPage'
}

export function RewriteInsufficientSourcesDialog({
  open,
  onOpenChange,
  translationKeyPrefix,
}: RewriteInsufficientSourcesDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(`${translationKeyPrefix}.rewriteInsufficientSourcesDialog.title`)}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(
              `${translationKeyPrefix}.rewriteInsufficientSourcesDialog.description`
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => onOpenChange(false)}>
            {t(`${translationKeyPrefix}.rewriteInsufficientSourcesDialog.close`)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
